import { ApisauceInstance, ApiResponse } from 'apisauce';

const getConfiguration = (
  api: ApisauceInstance,
): Promise<ApiResponse<MicrosoftSso.MicrosoftConfig>> =>
  api.get<MicrosoftSso.MicrosoftConfig>('/v1/sso/microsoft');

export default getConfiguration;
